import React, { Component } from "react";
import { connect } from 'react-redux'
import { Route, Redirect } from 'react-router-dom';
import { store } from '../index';

function SessionRequiredRoute({component: Component, ...rest}) {
    const renderFunc = (props, s) => {
        return store.getState().data.sessionID ? (
            <Component {...props} />
        ) : (
            <Redirect 
                to={{ pathname: "/" }} />
        )
    }
    return (
        <Route 
            {...rest}
            render = { props => renderFunc(props) }
        />
    );
}

const mapStateToProps = (state, ownState) => ({
    test: state.data,
})

export default connect(mapStateToProps, null)(SessionRequiredRoute);